import { Navigate, useRoutes } from 'react-router-dom';

import { PATH_AFTER_LOGIN } from 'src/config-global';

import { authRoutes } from './auth';
import { overviewRoutes } from './overview';
import { otherRoutes } from './other';
import { managementRoutes } from './management';
import { stockRoutes } from './stock';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },
    ...authRoutes,
    ...overviewRoutes,
    ...stockRoutes,
    ...managementRoutes,
    ...otherRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
